module.exports = __webpack_public_path__ + "img/video-frame.51ea1ead.svg";